"use strict";
var settings;
try {
  settings = require('settings');
} catch (e) {
  console.log("ERROR: could not get settings.");
  console.log("The HTML template must contain a <script> tag which includes the dynamic settings:");
  console.log("  <script type=\"text/javascript\" src=\"/settings\"></script>");
  throw e;
}
var imageUrl = settings.imageHostName + settings.imageHostPath + '?FIF=' + settings.imagePath;
var imageHostUrl = settings.imageHostName + settings.imageHostPath;
var imagePath = settings.imagePath;
var imageStaticPath = settings.imageStaticPath;
var thumbnailUrl = function(diaNr, width, height) {
  var path = imageUrl + '/' + diaNr + ".tif";
  if (typeof(width) != "undefined" && width)
    path = path + "&WID=" + width;
  if (typeof(height) != "undefined" && height)
    path = path + "&HEI=" + height;
  path = path + "&CVT=JPG";
  return path;
};
module.exports = {
  imageUrl: imageUrl,
  imageHostUrl: imageHostUrl,
  imagePath: imagePath,
  imageStaticPath: imageStaticPath,
  thumbnailUrl: thumbnailUrl
};
